var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('radio-player',{attrs:{"requestListUri":"/api/station/1/requests","downloadPlaylistUri":"/public/anarres/playlist.pls","nowPlayingUri":"https://admin.anarres.fm/api/nowplaying/1","useNchan":false,"radio-player":""}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }